// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectPurposeMeasurementQueryResult, selectPurposeMeasurementsPageLoading, selectPurposeMeasurementsShowInitWaitingMessage} from '../_selectors/purpose-measurement.selectors';

export class PurposeMeasurementsDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectPurposeMeasurementsPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectPurposeMeasurementsShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectPurposeMeasurementQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
